import cls from "classnames";
import React from 'react';

import NavLayout from "@qoohoo/common/components/NavBar/NavLayout";
import UserAvatar from "@qoohoo/common/components/UserAvatar";

import useEntityStore from "store/entityStore";
import { QOOHOO_WEBSITE_DOMAIN } from "constants/env";
import Link from 'next/link';


export default function Navbar({ className }) {
    const creator = useEntityStore((state) => state.entity?.data?.creator);
    function renderNameAndAvatar() {
        return (
          <Link href={`${QOOHOO_WEBSITE_DOMAIN}/${creator?.username}`} className="flex items-center">
            <div className="w-9 h-9 flex items-center justify-center rounded-full overflow-hidden mr-3 text-center text-white bg-[#2b3135]">
              <UserAvatar
                avatarUrl={creator?.avatar.url}
                userName={creator?.fullname}
                alt={creator?.fullname}
              />
            </div>
            <div className={cls("text-lg font-semibold")}>
              {creator?.fullname}
            </div>
          </Link>
        );
      }

  return (
    <NavLayout 
        className={className}
        theme = {{
            primaryColor: "#16191B",
        }}
        currentScreen="super_checkout"
        logoComponent={renderNameAndAvatar}
        navItems={null}
        authNavComponent={null}
        hamMenuComponent={null}
        extraComponent={null}
        isSticky={false}
    />
  )
}
